import { useEffect, useState } from 'react';
import { useRouteAnimation } from '@/contexts/AnimationContext';

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

function prefersReducedMotion(): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(REDUCED_MOTION).matches
      : false;
  } catch {
    return false;
  }
}

/** Live `prefers-reduced-motion: reduce`. */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(prefersReducedMotion);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(REDUCED_MOTION);
    const onChange = () => setReduced(query.matches);
    onChange();
    query.addEventListener?.('change', onChange);
    return () => query.removeEventListener?.('change', onChange);
  }, []);
  return reduced;
}

/**
 * The hero is still (no keyframes, no timers) when the player prefers reduced motion, or when
 * animations are off for Play in Sound & motion (global switch or the Play page switch:
 * the `home.guestHero` feature of the '/' animation preset).
 */
export function useStillHero(): boolean {
  const reduced = usePrefersReducedMotion();
  const animate = useRouteAnimation('home.guestHero');
  return reduced || !animate;
}
